import React, {memo} from "react";
import styles from './css/FJPreviewTips.module.less';
import classNames from 'classnames'

function FJPreviewTips(props) {
  let {point, text, active} = props
  return (
    <div className={classNames(styles.container, {[styles.active]: active})} style={point}>
      <p className={styles.text}>{text}</p>
    </div>
  )
}

export default memo(FJPreviewTips);